export default __webpack_public_path__ + "static/media/call-to-breath.85f4da68.jpg";